import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect, useRef } from 'react';
import { getScrollbarSize, PopoverSelector } from '@as/cotopaxi';
import { glossaryHighlighter } from '@as-react/common-utils';
const GLOSSARY_HIGHLIGHT_CLASS = 'glossary-highlight';
export const useGlossaryHighlightInPopover = (scrollContainer, isPopoverOpen) => {
    const isMobile = useMediaQueryMatchesOnMobile();
    const isHighlighted = useRef(false);
    useEffect(() => {
        const highlightGlossaryItems = () => {
            let scrollBarSize;
            const isScrollable = scrollContainer.current && scrollContainer.current.scrollHeight > scrollContainer.current.clientHeight;
            if (isScrollable) {
                scrollBarSize = getScrollbarSize();
            }
            const glossaryItems = Array.from(scrollContainer.current.querySelectorAll(`.${GLOSSARY_HIGHLIGHT_CLASS}`));
            const highlightedItems = scrollContainer.current.querySelectorAll(`a.${GLOSSARY_HIGHLIGHT_CLASS}`);
            /*
            If glossary items have been already highlighted (aem-platform-asadventure/app-package/jcr_root/apps/platform-asadventure/components/vendors/customlibs/glossaryHighlighter.ts)
            we have to destroy them and reinit with the correct configuration
            */
            highlightedItems.forEach(item => {
                // @ts-expect-error _tippy is added by AEM glossaryHighlighter
                if (item._tippy) {
                    // @ts-expect-error _tippy is added by AEM glossaryHighlighter
                    item._tippy.destroy();
                }
            });
            glossaryHighlighter(null, glossaryItems, {
                appendTo: () => scrollContainer.current.closest(`.${PopoverSelector.MODAL}`),
                placement: 'bottom-start',
                maxWidth: '100%',
                arrow: false,
                theme: 'glossary-light',
                onCreate(instance) {
                    if (isScrollable && scrollBarSize > 0) {
                        instance.popper.style.right = `${scrollBarSize}px`;
                    }
                    if (isMobile) {
                        instance.popper.style.maxHeight = '100vh';
                        instance.popperChildren.tooltip.style.maxHeight = '100vh';
                        instance.popperChildren.tooltip.style.overflowY = 'auto';
                    }
                },
            });
        };
        if ((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.current) && isPopoverOpen && !isHighlighted.current) {
            isHighlighted.current = true;
            highlightGlossaryItems();
        }
    }, [isPopoverOpen]);
};
